const styles = {
	checkbox: {
		color: "#767D90",
	},
};

export default styles;